module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.isHomePage && !_vm.isLoginPage) ? _c('mu-appbar', {
    staticClass: "example-appbar",
    class: {
      'nav-hide': !_vm.open
    },
    attrs: {
      "zDepth": 0
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "right",
      "label": "退出"
    },
    on: {
      "click": _vm.exit
    },
    slot: "right"
  }), _vm._v(" "), _c('app-tags')], 1) : _vm._e(), _vm._v(" "), (!_vm.isHomePage && !_vm.isLoginPage) ? _c('app-nav', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked
    },
    on: {
      "change": _vm.handleMenuChange,
      "close": _vm.toggleNav
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoginPage) ? _c('div', {
    staticClass: "example-content",
    class: {
      'nav-hide': !_vm.open, 'home-page': _vm.isHomePage
    }
  }, [(_vm.allowed) ? _c('router-view') : _c('div', [_vm._v("您没有当前页面访问权限")])], 1) : _c('div', [(_vm.allowed) ? _c('router-view') : _c('div', [_vm._v("您没有当前页面访问权限")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-826e63e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1393
// module chunks = 129